import { useState } from 'react'
import { COLORS, TYPE } from './tokens'

const FIELDS = [
  { key: 'title', label: 'Title', rows: 1 },
  { key: 'detail', label: 'Detail', rows: 4 },
  { key: 'business_impact', label: 'Business impact', rows: 3 },
  { key: 'rationale', label: 'Rationale', rows: 2 }
]

export default function FindingEditor({ finding, edits, onSave, onCancel }) {
  const initial = {}
  for (const f of FIELDS) {
    initial[f.key] = (edits && edits[f.key] != null) ? edits[f.key] : (finding?.[f.key] || '')
  }
  const [values, setValues] = useState(initial)
  const [saving, setSaving] = useState(false)

  const submit = async () => {
    setSaving(true)
    const changed = {}
    for (const f of FIELDS) {
      if (values[f.key] !== (finding?.[f.key] || '')) changed[f.key] = values[f.key]
    }
    await onSave?.(changed)
    setSaving(false)
  }

  return (
    <div style={{
      background: `${COLORS.amber}08`,
      border: `1px solid ${COLORS.amber}40`,
      borderRadius: '4px',
      padding: '20px',
      marginTop: '16px'
    }}>
      <div style={{ ...TYPE.smallCaps, color: COLORS.amber, marginBottom: '12px' }}>
        Modify finding
      </div>
      {FIELDS.map(f => (
        <div key={f.key} style={{ marginBottom: '16px' }}>
          <label style={{ ...TYPE.smallCaps, color: COLORS.mutedText, display: 'block', marginBottom: '4px' }}>
            {f.label}
          </label>
          {f.rows === 1 ? (
            <input
              type="text"
              value={values[f.key]}
              onChange={e => setValues(v => ({ ...v, [f.key]: e.target.value }))}
              style={{
                ...TYPE.body,
                width: '100%',
                padding: '8px 10px',
                border: `1px solid ${COLORS.hairline}`,
                borderRadius: '3px',
                background: COLORS.panelBg
              }}
            />
          ) : (
            <textarea
              rows={f.rows}
              value={values[f.key]}
              onChange={e => setValues(v => ({ ...v, [f.key]: e.target.value }))}
              style={{
                ...TYPE.body,
                width: '100%',
                padding: '8px 10px',
                border: `1px solid ${COLORS.hairline}`,
                borderRadius: '3px',
                background: COLORS.panelBg,
                fontFamily: 'inherit',
                resize: 'vertical'
              }}
            />
          )}
        </div>
      ))}
      <div style={{ display: 'flex', gap: '8px', justifyContent: 'flex-end' }}>
        <button
          onClick={onCancel}
          disabled={saving}
          style={{
            ...TYPE.supporting, padding: '6px 12px',
            background: 'transparent', color: COLORS.bodyText,
            border: `1px solid ${COLORS.hairline}`, borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Cancel
        </button>
        <button
          onClick={submit}
          disabled={saving}
          style={{
            ...TYPE.supporting, padding: '6px 14px',
            background: COLORS.amber, color: COLORS.panelBg,
            border: 'none', borderRadius: '4px', cursor: 'pointer'
          }}
        >
          {saving ? 'Saving…' : 'Save changes'}
        </button>
      </div>
    </div>
  )
}
